import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import ActionButton from './ActionButton';

const ActionButtonWithLoading = ({ label, onClick, customStyles = {}, actionLoading = false }) => (
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    <Box sx={{ position: 'relative' }}>
      <ActionButton label={label} actionLoading={actionLoading} customStyles={customStyles} onClick={onClick} />
      {actionLoading && (
        <CircularProgress
          size={24}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
          }}
        />
      )}
    </Box>
  </Box>
);

export default ActionButtonWithLoading;
